import * as signalR from '@microsoft/signalr';

let config = {
  apiSpmHost: "https://spm-api.slidespiel.com",
  // apiSpmHost: "https://ssp-spm-api-ai-chat-bot.azurewebsites.net",
  apiPortalHost: "https://api.slidespiel.com",
  // apiExportHost: "http://localhost:8080",
  apiExportHost: "https://video-export.slidespiel.com",
  apiSignalRHost: "https://ssprealtimeapi.azurewebsites.net",
  chatRealm: "https://chat.slidespiel.com",
  imageQuality: 3,
  // captionsServer: "http://localhost:3005",
  captionsServer: "https://live-captions-broadcaster.slidespiel.com",
  // signallingServer: "http://localhost:3001",
  signallingServer: "https://rtc.slidespiel.com",
  // configuratorHost: "http://localhost:3003",
  configuratorHost: "https://website-configurator.slidespiel.com",
  configuratorApiKey: "key1",
  configuratorBaseDomain: "slidespiel.com",
  // amplitudeKey: "bc984d3a3a4d5e3ae76ea8463804ddb0",
  sendChunks: true,
  debug: "mediasoup-client:none",
  version: "1.30.6",
  showMs: true,
  uniqueStreamerNames: true,
  feedQueryCount: 9999999,
  maxUnpublishedRecordings: 10,
  disablePreroll: true,
  // spmDomains: [{ domain: "localhost", spm: "test-spm" }],
  spmDomains: [],
  defaultSyncDate: "2027-01-21",
  // defaultSyncDate: "2024-09-23",
  // spellChecker: disable-next-line,
  captchaSiteKey: "6Lfm-tMmAAAAAB5wrrJQOTTVO0wJ_DysZ-mucuoI",
  showFilterCollapseButton: true,
  enableRecorderSettingsVideoStreamToggle: true,
  signalRLogLevel: signalR.LogLevel.Information,
  googleMapsApiKey: "AIzaSyA6ffZNxXUf3T34gwt3s7-dXyFpAaQ6A9w",
};
// eslint-disable-next-line
if (process.env.NODE_ENV === "production") {
  config = {
    ...config, ...{
      imageQuality: 1,
      signallingServer: "https://rtc.slidespiel.com",
      // amplitudeKey: "5d638d7af30ced527d1fa80d2c5bd116",
      sentryDsn: "https://36847a217c354163b2f67ff6e413075f@o361175.ingest.sentry.io/5195220",
      sendChunks: true,
      debug: "mediasoup-client:*",
      showMs: false,
      uniqueStreamerNames: true,
      feedQueryCount: 100,
      disablePreroll: false,
      spmDomains: [],
      defaultSyncDate: null,
      showFilterCollapseButton: false,
      enableRecorderSettingsVideoStreamToggle: false,
      signalRLogLevel: signalR.LogLevel.None,
      // TODO: set real deployed Website Configurator host + API key for production.
      // The API key ships in the browser bundle (direct-call design); rotate it and rely on the service CORS allow-list.
      configuratorHost: "https://website-configurator.slidespiel.com",
      configuratorApiKey: "key1",
      maxUnpublishedRecordings: 30,
    }
  };
}

export default config;
